import styled from "styled-components";

// Terminal-style corner ticks rendered on hero/feature cards (PRD visual system).
// Four absolutely-positioned L-brackets in the card corners.
const Tick = styled.span`
  position: absolute;
  width: 10px;
  height: 10px;
  border-color: rgba(255, 255, 255, 0.18);
  border-style: solid;
  border-width: 0;
  pointer-events: none;
`;

const TL = styled(Tick)`
  top: 8px;
  left: 8px;
  border-top-width: 1.5px;
  border-left-width: 1.5px;
`;
const TR = styled(Tick)`
  top: 8px;
  right: 8px;
  border-top-width: 1.5px;
  border-right-width: 1.5px;
`;
const BL = styled(Tick)`
  bottom: 8px;
  left: 8px;
  border-bottom-width: 1.5px;
  border-left-width: 1.5px;
`;
const BR = styled(Tick)`
  bottom: 8px;
  right: 8px;
  border-bottom-width: 1.5px;
  border-right-width: 1.5px;
`;

export function CornerTicks() {
  return (
    <>
      <TL />
      <TR />
      <BL />
      <BR />
    </>
  );
}
